import { cn } from "$/lib/utils/functions/misc.functions";
import { Checkbox } from "../../atoms";
import Flexbox from "../../common/Flexbox";
import type { CheckboxSetProps } from "./CheckboxSet.types";

const CheckboxSet = <T extends string | number>({
  id,
  title,
  options,
  selected,
  onChange,
  row = false,
  className,
}: CheckboxSetProps<T>) => {
  return (
    <Flexbox
      row={row}
      className={cn(
        "gap-1.5",
        {
          "gap-3": row,
        },
        className,
      )}
    >
      <p className="whitespace-nowrap text-base font-semibold text-secondary">
        {title}
      </p>
      {options.map((option) => (
        <label htmlFor={id} className="flex items-center gap-2" key={option.id}>
          <Checkbox
            name={id}
            checked={selected[option.id]}
            onChange={() => onChange(option.id, !selected[option.id])}
          />
          <span className="text-sm font-medium text-primary">
            {option.label}
          </span>
        </label>
      ))}
    </Flexbox>
  );
};

export default CheckboxSet;
